"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSummaryItem = void 0;
function isSummaryItem(item) {
    return item.title !== undefined;
}
exports.isSummaryItem = isSummaryItem;
